import React from 'react';

// A deploy replaces the content-hashed bundles, so a tab that was open before it
// landed asks for a chunk that no longer exists. React unmounts the whole tree on
// that rejection, which used to leave a completely white page with no way back.
const CHUNK_ERROR = /Loading chunk \S+ failed|Loading CSS chunk|dynamically imported module|Importing a module script failed|error loading dynamically imported module/i;

const RELOAD_SENTINEL = 'chunkReloaded';

export function clearChunkReloadSentinel() {
  try {
    sessionStorage.removeItem(RELOAD_SENTINEL);
  } catch (e) {
    /* sessionStorage can be unavailable in private mode; nothing to clean up */
  }
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Render error:', error, info);
    if (!CHUNK_ERROR.test(String(error && error.message))) return;
    // Reload once to pick up the new bundle. The sentinel stops a reload loop
    // if the fresh bundle is broken too; it is cleared as soon as any lazy
    // chunk loads successfully (see lazyRoute in App.js).
    try {
      if (!sessionStorage.getItem(RELOAD_SENTINEL)) {
        sessionStorage.setItem(RELOAD_SENTINEL, '1');
        window.location.reload();
      }
    } catch (e) {
      /* sessionStorage unavailable — fall through to the manual reload button */
    }
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="loading-screen">
        <div>MODULE FAILED TO LOAD.</div>
        <button
          className="btn btn-primary"
          style={{ marginTop: '1rem' }}
          onClick={() => window.location.reload()}
        >
          RELOAD
        </button>
      </div>
    );
  }
}

export default ErrorBoundary;
